export const CLEAR_USER = 'CLEAR_USER';

export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_ERROR = 'DELETE_USER_ERROR';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';

export const GET_USERS = 'GET_USERS';
export const GET_USERS_ERROR = 'GET_USERS_ERROR';
export const GET_USERS_SUCCESS = 'GET_USERS_SUCCESS';

export const SEARCH_USERS = 'SEARCH_USERS';
export const SEARCH_USERS_ERROR = 'SEARCH_USERS_ERROR';
export const SEARCH_USERS_SUCCESS = 'SEARCH_USERS_SUCCESS';

export const GET_USER = 'GET_USER';
export const GET_USER_ERROR = 'GET_USER_ERROR';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';

export const SAVE_USER = 'SAVE_USER';
export const SAVE_USER_ERROR = 'SAVE_USER_ERROR';
export const SAVE_USER_SUCCESS = 'SAVE_USER_SUCCESS';

export const SAVE_PASSWORD = 'SAVE_PASSWORD';
export const SAVE_PASSWORD_ERROR = 'SAVE_PASSWORD_ERROR';
export const SAVE_PASSWORD_SUCCESS = 'SAVE_PASSWORD_SUCCESS';

export const SAVE_USER_SIMPLE = 'SAVE_USER_SIMPLE';
export const SAVE_USER_SIMPLE_ERROR = 'SAVE_USER_SIMPLE_ERROR';
export const SAVE_USER_SIMPLE_SUCCESS = 'SAVE_USER_SIMPLE_SUCCESS';

export const GET_BOARD_MEMBER = 'GET_BOARD_MEMBER';
export const GET_BOARD_MEMBER_ERROR = 'GET_BOARD_MEMBER_ERROR';
export const GET_BOARD_MEMBER_SUCCESS = 'GET_BOARD_MEMBER_SUCCESS';



// WEBPACK FOOTER //
// ./src/components/Users/constants.js